<script setup>
import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { ButtonComponent } from '@/components';
import { useScreenSize } from '@/composables/useScreenSize';
const { screenSize } = useScreenSize();
const isMobile = computed(() => screenSize.value === 'mobile');

// showHeroSection() {
//   return (
//     (!this.latest_carrier_eld_provider?.integration?.id ||
//       this.hasInvalidEldCredentials ||
//       this.hasUnverifiedEldCredentials) &&
//     this.latest_carrier_eld_provider_has_loaded
//   );
//   // return this.latest_carrier_eld_provider?.id > 0 && this.latest_carrier_eld_provider_has_loaded;
// },

//     latest_carrier_eld_provider() {
//   if (this.$store.state.onboardingPacket?.latest_carrier_eld_provider) {
//     return this.$store.state.onboardingPacket?.latest_carrier_eld_provider;
//   } else if (
//     this.$store.state.carriers?.carrierData?.latest_carrier_eld_provider
//   ) {
//     return this.$store.state.carriers?.carrierData
//       ?.latest_carrier_eld_provider;
//   }
//   return null;
// },

// hasInvalidEldCredentials() {
//   return (
//     (this.latest_carrier_eld_provider?.integration
//       ?.eld_credentials_verified === false &&
//       this.latest_carrier_eld_provider?.connect_channel
//         ?.is_auto_eld_credentials) ||
//     this.latest_carrier_eld_provider?.integration?.revoked_at !== null
//   );
// },
// hasUnverifiedEldCredentials() {
//   return (
//     this.latest_carrier_eld_provider?.integration
//       ?.eld_credentials_verified === null &&
//     this.latest_carrier_eld_provider?.connect_channel
//       ?.is_auto_eld_credentials
//   );
// },
// hasValidEldCredentials() {
//   return (
//     this.latest_carrier_eld_provider?.integration
//       ?.eld_credentials_verified &&
//     this.latest_carrier_eld_provider?.connect_channel
//       ?.is_auto_eld_credentials
//   );
// },

const { containerClass } = defineProps({
  containerClass: {
    type: String,
    required: false,
    default: 'w-full',
  },
});
const defaultTitle = 'Connect your ELD';
const defaultMessage = 'Build trust and visibility to get more freight';
const title = ref(defaultTitle);
const buttonText = ref(defaultTitle);
const message = ref(defaultMessage);
const store = useStore();
const handleConnectEldClick = () => {
  if (buttonText.value !== defaultTitle) {
    store.commit('integrations/setUpdateEld', true);
  }
  store.commit('myLoadsStore/setShowConnectEldDialog', true);
};
const showEldButton = ref(false);
const hasLatestEldProviderLoaded = computed(
  () => store.state.onboardingPacket?.hasLatestEldProviderLoaded
);
const latestEldCarrierProvider = computed(
  () => store.state.onboardingPacket?.latest_carrier_eld_provider
);
const hasInvalidEldCredentials = computed(() => {
  return (
    (latestEldCarrierProvider.value?.integration?.eld_credentials_verified ===
      false &&
      latestEldCarrierProvider.value?.connect_channel
        ?.is_auto_eld_credentials) ||
    latestEldCarrierProvider.value?.integration?.revoked_at !== null
  );
});
const hasUnverifiedEldCredentials = computed(() => {
  return (
    latestEldCarrierProvider.value?.integration?.eld_credentials_verified ===
      null &&
    latestEldCarrierProvider.value?.connect_channel?.is_auto_eld_credentials
  );
});
watch(
  () => hasLatestEldProviderLoaded.value,
  (newValue) => {
    if (newValue) {
      if (
        (!latestEldCarrierProvider.value?.integration?.id ||
          hasInvalidEldCredentials.value ||
          hasUnverifiedEldCredentials.value) &&
        latestEldCarrierProvider.value?.connect_channel?.eld_type !==
          'eld_exempt' &&
        !latestEldCarrierProvider.value?.has_setup_manual_connection
      ) {
        showEldButton.value = true;
        if (!latestEldCarrierProvider.value?.integration?.id) {
          title.value = defaultTitle;
          buttonText.value = defaultTitle;
          message.value = defaultMessage;
        } else if (hasInvalidEldCredentials.value) {
          title.value = 'Invalid ELD Credentials';
          buttonText.value = 'Update Credentials';
          message.value = `${latestEldCarrierProvider.value?.connect_channel?.name}
                    account credentials are invalid`;
        } else if (hasUnverifiedEldCredentials.value) {
          title.value = 'ELD Connection in Progress';
          buttonText.value = 'Update Credentials';
          message.value = `We're currently working on connecting
                    ${latestEldCarrierProvider.value?.connect_channel?.name}`;
        }
      } else {
        showEldButton.value = false;
      }
    }
  }
);
</script>

<template>
  <div
    v-if="showEldButton"
    class="z-[1] flex flex-col items-center justify-center gap-2 overflow-hidden rounded-xl bg-white p-4 outline outline-1 outline-offset-[-1px] outline-neutral-300-a"
    :class="[containerClass, { 'mt-5 shadow-md': !isMobile }]"
  >
    <div
      class="flex h-[75px] flex-col items-center"
      :class="{ 'h-[75px]': !isMobile }"
    >
      <div class="relative overflow-hidden">
        <img
          src="@/assets/eld-yellow.svg"
          class="w-[20px]"
          alt="eld icon"
        />
      </div>
      <div
        class="flex flex-col items-start justify-start gap-0.5 self-stretch overflow-hidden"
      >
        <div
          class="text-color-text-neutral-bold-default justify-start self-stretch text-center font-['Poppins'] text-base font-semibold leading-normal tracking-tight"
        >
          {{ title }}
        </div>
        <div
          class="w-full justify-start text-center text-sm font-medium leading-tight tracking-tight text-steel-800"
        >
          {{ message }}
        </div>
      </div>
    </div>

    <ButtonComponent
      variant="primary"
      class="w-full"
      @click="handleConnectEldClick"
    >
      {{ buttonText }}
    </ButtonComponent>
  </div>
</template>

<style lang="scss" scoped></style>
